import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

export const AudioPlayer = ({ audioSrc, sx, size, hideCaption }) => {
    const { t } = useTranslation();
    if (hideCaption === undefined) {
        hideCaption = false;
    }
    if (size === undefined) {
        size = "40px";
    }
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);
    const theme = useTheme();

    useEffect(() => {
        if (audioSrc) {
            audioRef.current = new Audio(audioSrc);
        }
    }, [audioSrc]);

    const togglePlayPause = () => {
        if (!audioRef.current) return;
        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    if (!audioSrc) return null;

    return (
        <Box sx={{display: "flex", flexFlow: "column nowrap", gap: "5px", alignItems: "center", ...sx }}>
            <IconButton className="AudioPlayer" onClick={togglePlayPause} sx={{
                width: size,
                height: size,
                // FIXME use theme
                color: "white",
                boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
                background: 'linear-gradient(45deg, #9d59f1 30%, #0be3be 90%)',
                ":hover": {
                    background: 'linear-gradient(45deg, #9d59f1 60%, #0be3be 100%)',
                },
            }}>
                {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
            </IconButton>
            {!hideCaption &&
                <Box sx={{
                    fontSize: "10px",
                    color: theme.palette.primary.main
                }}>{t("audioplayer-listen")}</Box>
            }
        </Box>
    );
};
